<template>
  <body>
  <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
  <div>
	<header>
		<div class="header_logo">
			<h1><a href="/"><img :src="$t('logo_oures.path')" :alt="$t('logo_oures.alt')" :class="imgClass"></a></h1>
		</div>
		<div class="header_box">
			<p><a href="#" onClick="toggle_item('head_search','<img src=\'image/icon_h_search.svg\'>',this); return false;" id="head_search_icon">
				<img src="image/icon_h_search.svg"></a>
			</p>
			<p class="header_lang">
				<a href="#" @click.prevent="change_locale">{{ $t('change_locale') }}</a>
			</p>
		</div>		
	</header>

<!--研究者を検索 ヘッダー検索ボタンクリック時-->

		<div id="head_search">
			<div class="head_search_close">
				<a href="#" onClick="var obj=document.getElementById('head_search_icon');toggle_item('head_search','',obj); return false;">
					<img src="image/icon_h_close.svg">
				</a>
			</div>
			<div class="head_search_container">
				<div class="head_search_ttl">
					{{ $t('search_researchers') }}
				</div>
				<div>
					<form method="get" @submit.prevent="search_by_keyword" class="search_container">
						<input type="text" name="k" size="25" :placeholder="$t('search_by_keyword')" class="search_container_txt" v-model="keyword_top">
						<input type="image" src="image/icon_search_circle.svg" onMouseOver="this.src='image/icon_search_circle_on.svg'"  onmouseout="this.src='image/icon_search_circle.svg'" alt="検索" class="search_container_img">
					</form>
				</div>

				<div class="search_post_area">
						<HowToUseHeader />
						<ul class="keyword_boolean_list right-side">
							<li class="keyword_boolean" :class="{ 'btn_check': operator === 'AND' }" @click="operator = 'AND'">{{ $t('and_search') }}</li>
							<li class="keyword_boolean" :class="{ 'btn_check': operator === 'OR' }" @click="operator = 'OR'">{{ $t('or_search') }}</li>
						</ul>
				</div>

				<div style="margin-top: 20px;">
					<form method="get" @submit.prevent="search_by_name" class="search_container">
						<input type="text" name="k" size="25" :placeholder="$t('search_by_name')" class="search_container_txt" v-model="name_top">
						<input type="image" src="image/icon_search_circle.svg" onMouseOver="this.src='image/icon_search_circle_on.svg'"  onmouseout="this.src='image/icon_search_circle.svg'" alt="検索" class="search_container_img">
					</form>
				</div>
							<div id="search_double">
<!--専門分野で検索-->
				<div class="search_spfield accordion_big">
					<div class="search_spfield_ttl button_big">{{ $t('search_by_field') }}</div>
					<div class="division_contener nest_big">
						<div class="scroll_bar">
							<ul>
								<li class="accordion" v-for="discipline in research_areas" :key="discipline.code">
									<div class="division_list button">
										<a href="#" @click.prevent="search_by_area_lv1(discipline.code)">{{ discipline[lang] }}</a>
									</div>
									<div class="division_list_in nest">
										<ul>
											<a href="#" @click.prevent="search_by_area_lv2(field.code)" v-for="field in discipline.items" :key="field.code"><li>{{ field[lang] }}</li></a>
										</ul>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
<!--所属で検索-->
				<div class="search_spfield accordion_big">
					<div class="search_spfield_ttl button_big">{{ $t('search_by_department') }}</div>
					<div class="division_contener nest_big">
						<div class="scroll_bar">
							<ul>
								<li class="accordion" v-for="o1 in organizations" :key="o1.key">
									<div class="division_list button">
										<div @click.prevent="search_by_org_lv1(o1.code)">{{ o1[lang] }}</div>
									</div>
									<div class="division_list_in nest">
										<ul>
											<a href="#" @click.prevent="search_by_org_lv2(o2.code)" v-for="o2 in o1.items" :key="o2.code"><li>{{ o2[lang] }}</li></a>
										</ul>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
<!--/所属で検索-->
					</div>
				</div>
			</div>
<!--/研究者を検索 ヘッダー検索ボタンクリック時-->		
	
	<main>
<!--さらに研究者を検索 左窓-->
		<div id="search_container">
			<div class="search_container_in">
				<h2>{{ $t('filter_by') }}</h2>
				<div>
					<link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet">
					<form method="get" class="search_container_min" @submit.prevent="search_and_go_to_top">
					  <input type="text" name="k" size="25" :placeholder="$t('enter_keyword')" v-model="keyword">
					  <input type="submit" class="fa fa-search">
					</form>
					<div class="search_post_area">
						<HowToUse />
						<ul class="keyword_boolean_list right-side">
							<li class="keyword_boolean" :class="{ 'btn_check': operator === 'AND' }" @click="operator = 'AND'">{{ $t('and_search') }}</li>
							<li class="keyword_boolean" :class="{ 'btn_check': operator === 'OR' }" @click="operator = 'OR'">{{ $t('or_search') }}</li>
						</ul>
				</div>
				</div>
				<hr>
				<div>
					<link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet">
					<form method="get" class="search_container_min" @submit.prevent="search_and_go_to_top">
					  <input type="text" name="k" size="225" :placeholder="$t('enter_name')" v-model="name">
					  <input type="submit" class="fa fa-search">
					</form>
				</div>
				<hr>
				<div class="search_post_area">
					<div class="search_post_ttl">{{ $t('post') }}</div>
					<div>
						<ul>
							<a href="#" @click.prevent="choose_job('1', $event)" v-bind:class="{'active':job == '1', 'disabled':!filtered_jobs.some(j => j.code == '1')}"><li>{{ $t('post_kyoju') }}</li></a>
							<a href="#" @click.prevent="choose_job('2', $event)" v-bind:class="{'active':job == '2', 'disabled':!filtered_jobs.some(j => j.code == '2')}"><li>{{ $t('post_junkyoju') }}</li></a>
							<a href="#" @click.prevent="choose_job('3', $event)" v-bind:class="{'active':job == '3', 'disabled':!filtered_jobs.some(j => j.code == '3')}"><li>{{ $t('post_koshi') }}</li></a>
						</ul>
						<ul>
							<a href="#" @click.prevent="choose_job('4', $event)" v-bind:class="{'active':job == '4', 'disabled':!filtered_jobs.some(j => j.code == '4')}"><li>{{ $t('post_jokyo') }}</li></a>
							<a href="#" @click.prevent="choose_job('5', $event)" v-bind:class="{'active':job == '5', 'disabled':!filtered_jobs.some(j => j.code == '5')}"><li>{{ $t('post_sonota') }}</li></a>
						</ul>	
					</div>
				</div>
<!--所属で検索-->
				<div class="search_belongs accordion">
					<div class="search_belongs_in button">{{ $t('department') }}</div>		
					<div id="belongs_more" class="search_belongs_list nest">
						<ul>
							<a href="#" @click.prevent="choose_organization(o1.code, $event)" v-bind:class="{'active':org_lv1 == o1.code}" v-for="(o1, index) in filtered_organizations" :key="o1.code">
								<li v-bind:class="{last: index == filtered_organizations.length - 1}">{{ o1[lang] }}</li>
							</a>
						</ul>
					</div>
				</div>
<!--専門分野で検索-->
				<div class="search_fields accordion">
					<div class="search_fields_in button">{{ $t('research_area') }}</div>		
					<div id="fields_more" class="search_fields_list nest">
						<ul>
							<a href="#" @click.prevent="choose_research_area(a1.code, $event)" v-bind:class="{'active':area_lv1 == a1.code}" v-for="(a1, index) in filtered_research_areas" :key="a1.code">
								<li v-bind:class="{last: index == filtered_research_areas.length - 1}">{{ a1[lang] }}</li>
							</a>
						</ul>
					</div>
				</div>
<!--検索-->
				<div class="search_more_btn">
					<a href="#" @click.prevent="search_and_go_to_top"><p>{{ $t('search') }}</p></a>
				</div>
				<hr>
<!--表示順-->
				<div class="search_sort accordion">
					<div class="search_sort_in button">{{ $t('sort_by') }}</div>		
					<div id="turn" class="search_sort_list nest">
						<ul>
						<a href="#" @click.prevent="choose_sort('na', $event)" v-bind:class="{active:sort == 'na'}"><li>{{ $t('sort_by_name_asc') }}</li></a>
						<a href="#" @click.prevent="choose_sort('nd', $event)" v-bind:class="{active:sort == 'nd'}"><li>{{ $t('sort_by_name_desc') }}</li></a>
						<a href="#" @click.prevent="choose_sort('o', $event)" v-bind:class="{active:sort == 'o'}"><li>{{ $t('sort_by_department') }}</li></a>
						<a href="#" @click.prevent="choose_sort('j', $event)" v-bind:class="{active:sort == 'j'}"><li class="last">{{ $t('sort_by_post') }}</li></a>
						</ul>
					</div>
				</div>
<!--表示件数-->
				<div class="search_size accordion">
					<div class="search_size_in button">{{ $t('display_count') }}</div>		
					<div id="number" class="search_size_list nest">
						<ul>
							<a href="#" @click.prevent="choose_size(10, $event)" v-bind:class="{active:size == 10}"><li>{{ $t('display_count_10') }}</li></a>
							<a href="#" @click.prevent="choose_size(20, $event)" v-bind:class="{active:size == 20}"><li>{{ $t('display_count_20') }}</li></a>
							<a href="#" @click.prevent="choose_size(30, $event)" v-bind:class="{active:size == 30}"><li>{{ $t('display_count_30') }}</li></a>
							<a href="#" @click.prevent="choose_size(50, $event)" v-bind:class="{active:size == 50}"><li>{{ $t('display_count_50') }}</li></a>
							<a href="#" @click.prevent="choose_size(100, $event)" v-bind:class="{active:size == 100}"><li class="last">{{ $t('display_count_100') }}</li></a>
						</ul>
					</div>
				</div>
<!--並び替え-->
				<div class="search_more_btn">
					<a href="#" @click.prevent="search_and_go_to_top"><p>{{ $t('sort') }}</p></a>
				</div>
			</div>
		</div>
<!--/さらに研究者を検索 左窓-->
		
<!--右エリア-->
		
		<article id="res_container">
		
<!--さらに研究者を検索 横幅960px以下の時表示-->
			<div class="search_more_r_wrapper accordion">
				<div class="search_more_r button">{{ $t('filter_by') }}</div>		
				<div class="disp_u960 nest">
					<div class="search_container_in">
						<div>
							<link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet">
							<form method="get" class="search_container_min" @submit.prevent="search_and_go_to_top">
							  <input type="text" size="25" :placeholder="$t('search_by_keyword')" v-model="keyword">
							  <input type="submit" class="fa fa-search">
							</form>
							<div class="search_post_area">
								<HowToUseMobile />
								<ul class="keyword_boolean_list right-side">
									<li class="keyword_boolean" :class="{ 'btn_check': operator === 'AND' }" @click="operator = 'AND'">{{ $t('and_search') }}</li>
									<li class="keyword_boolean" :class="{ 'btn_check': operator === 'OR' }" @click="operator = 'OR'">{{ $t('or_search') }}</li>
								</ul>
							</div>
						</div>
						<hr>
						<div>
							<link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet">
							<form method="get" class="search_container_min" @submit.prevent="search_and_go_to_top">
								<input type="text" name="k" size="225" :placeholder="$t('enter_name')" v-model="name">
								<input type="submit" class="fa fa-search">
							</form>
						</div>
						<hr>
						<div class="search_post_area">
							<div class="search_post_ttl">{{ $t('post') }}</div>
								<div>
									<ul>
										<a href="#" @click.prevent="choose_job('1', $event)" v-bind:class="{'active':job == '1', 'disabled':!filtered_jobs.some(j => j.code == '1')}"><li>{{ $t('post_kyoju') }}</li></a>
										<a href="#" @click.prevent="choose_job('2', $event)" v-bind:class="{'active':job == '2', 'disabled':!filtered_jobs.some(j => j.code == '2')}"><li>{{ $t('post_junkyoju') }}</li></a>
										<a href="#" @click.prevent="choose_job('3', $event)" v-bind:class="{'active':job == '3', 'disabled':!filtered_jobs.some(j => j.code == '3')}"><li>{{ $t('post_koshi') }}</li></a>
										<a href="#" @click.prevent="choose_job('4', $event)" v-bind:class="{'active':job == '4', 'disabled':!filtered_jobs.some(j => j.code == '4')}"><li>{{ $t('post_jokyo') }}</li></a>
										<a href="#" @click.prevent="choose_job('5', $event)" v-bind:class="{'active':job == '5', 'disabled':!filtered_jobs.some(j => j.code == '5')}"><li>{{ $t('post_sonota') }}</li></a>
									</ul>	
								</div>
							</div>
<!--所属で検索-->
						<div class="search_belongs accordion">
							<div class="search_belongs_in button">{{ $t('department') }}</div>
							<div id="belongs_more" class="search_belongs_list nest">
								<ul>
									<a href="#" @click.prevent="choose_organization(o1.code, $event)" v-bind:class="{'active':org_lv1 == o1.code}" v-for="(o1, index) in filtered_organizations" :key="o1.code">
										<li v-bind:class="{last: index == filtered_organizations.length - 1}">{{ o1[lang] }}</li>
									</a>
								</ul>
							</div>
						</div>
<!--専門分野で検索-->
						<div class="search_fields accordion">
							<div class="search_fields_in button">{{ $t('research_area') }}</div>		
							<div id="fields_more" class="search_fields_list nest">
								<ul>
									<a href="#" @click.prevent="choose_research_area(a1.code, $event)" v-bind:class="{'active':area_lv1 == a1.code}" v-for="(a1, index) in filtered_research_areas" :key="a1.code">
										<li v-bind:class="{last: index == filtered_research_areas.length - 1}">{{ a1[lang] }}</li>
									</a>
								</ul>
							</div>
						</div>
<!--検索-->
						<div class="search_more_btn">
							<a href="#" @click.prevent="search_and_go_to_top"><p>{{ $t('search') }}</p></a>
						</div>
						<hr>
<!--表示順-->
						<div class="search_belongs accordion">
							<div class="search_belongs_in button">{{ $t('sort_by') }}</div>		
							<div id="turn_u" class="search_belongs_list nest">
								<ul>
								<a href="#"><li>{{ $t('sort_by_name_asc') }}</li></a>
								<a href="#"><li>{{ $t('sort_by_name_desc') }}</li></a>
								<a href="#"><li>{{ $t('sort_by_department') }}</li></a>
								<a href="#"><li>{{ $t('sort_by_post') }}</li></a>
								</ul>
							</div>
						</div>
<!--表示件数-->
						<div class="search_belongs accordion">
							<div class="search_belongs_in button">{{ $t('display_count') }}</div>		
							<div id="number_u" class="search_belongs_list nest">
								<ul>
									<a href="#" @click.prevent="choose_size(10, $event)" v-bind:class="{active:size == 10}"><li>{{ $t('display_count_10') }}</li></a>
									<a href="#" @click.prevent="choose_size(20, $event)" v-bind:class="{active:size == 20}"><li>{{ $t('display_count_20') }}</li></a>
									<a href="#" @click.prevent="choose_size(30, $event)" v-bind:class="{active:size == 30}"><li>{{ $t('display_count_30') }}</li></a>
									<a href="#" @click.prevent="choose_size(50, $event)" v-bind:class="{active:size == 50}"><li>{{ $t('display_count_50') }}</li></a>
									<a href="#" @click.prevent="choose_size(100, $event)" v-bind:class="{active:size == 100}"><li class="last">{{ $t('display_count_100') }}</li></a>
								</ul>
							</div>
						</div>
<!--並び替え-->
						<div class="search_more_btn">
							<a href="#" @click.prevent="search_and_go_to_top"><p>{{ $t('sort') }}</p></a>
						</div>
					</div>
				</div>
			</div>
<!--/さらに研究者を検索 横幅960px以下の時表示-->

			<h3 v-if="total > 0 && researchers.length > 0">{{ $t('search_result_1') }}{{ total }}{{ $t('search_result_2') }}　{{ start }}-{{ end }}{{ $t('search_result_3') }}</h3>
			<section id="res_list">
				<dl v-for="researcher in researchers" :key="researcher.permalink">
					<dt>
						<a :href="host + '/' + lang + '/' + researcher.urn + '.html' + (keyword ? '?k=' + keyword : '')">
							<img v-if="researcher.image" :src="researcher.image">
							<img v-else src="image/photo_drwan_640.png">
						</a>
					</dt>
					<dd>
						<h4 style="margin: 0; font-size: 16px;"><a :href="host + '/' + lang + '/' + researcher.urn + '.html' + (keyword ? '?k=' + keyword : '')" style="text-decoration: none; color: black;">{{ researcher.name }}</a></h4>
						<h5 style="margin: 5px 0; font-size: 14px; color: gray;"><a :href="host + '/' + lang + '/' + researcher.urn + '.html' + (keyword ? '?k=' + keyword : '')" style="text-decoration: none; color: gray;">{{ researcher.sub_name }}</a></h5>
						<!-- <h6 style="margin: 0; font-size: 12px; color: darkgray;"><a :href="host + '/' + lang + '/' + researcher.urn + '.html' + (keyword ? '?k=' + keyword : '')" style="text-decoration: none; color: darkgray;">{{ researcher.org_name }}<span>，</span>{{ researcher.job_name }}</a></h6> -->
						<!-- ▼ 条件分岐：isVisiting=false のとき今まで通り -->
						<h6 v-if="!researcher.isVisiting" style="margin: 0; font-size: 12px; color: darkgray;">
						<a class="link"
							:href="host + '/' + lang + '/' + researcher.urn + '.html' + (keyword ? '?k=' + keyword : '')">
							{{ researcher.org_name }}<span>，</span>{{ researcher.job_name }}
						</a>
						</h6>

						<!-- ▼ isVisiting=true のとき visitingStrings を改行表示 -->
						<h6 v-else style="margin: 0; font-size: 12px; color: darkgray;">
						<a class="link"
							:href="host + '/' + lang + '/' + researcher.urn + '.html' + (keyword ? '?k=' + keyword : '')">
							<span v-for="(v, idx) in researcher.visiting" :key="idx">
							<span v-if="lang === 'ja'"><span>{{ v.orgJa }}</span><span>，</span><span>{{ v.jobJa }}</span></span>
							<span v-else><span>{{ v.orgEn }}</span><span>，</span><span>{{ v.jobEn }}</span></span>
							<br>
							</span>
						</a>
						</h6>
					</dd>
				</dl>
			</section>
			<!--
			<section id="res_list">
				<dl v-for="researcher in researchers" :key="researcher.permalink">
					<dt>
						<a :href="host + '/' + lang + '/' + researcher.urn + '.html' + (keyword ? '?k=' + keyword : '')">
							<img v-if="researcher.image" :src="researcher.image">
							<img v-else src="image/photo_drwan_640.png">
						</a>
					</dt>
					<dd><h4><a :href="host + '/' + lang + '/' + researcher.urn + '.html' + (keyword ? '?k=' + keyword : '')">{{ researcher.name }}</a></h4></dd>
					<dd><h5><a :href="host + '/' + lang + '/' + researcher.urn + '.html' + (keyword ? '?k=' + keyword : '')">{{ researcher.sub_name}}</a></h5></dd>
					<dd><h6><a :href="host + '/' + lang + '/' + researcher.urn + '.html' + (keyword ? '?k=' + keyword : '')">{{ researcher.org_name }}<span>，</span>{{ researcher.job_name }}</a></h6></dd>
				</dl>
			</section>
			-->
			<div class="page_nav" v-if="researchers.length > 0">
				<ul>
					<li>
						<a v-if="page > 1" href="#" @click.prevent="choose_page(page - 1)">◀</a>
						<span v-else>◀</span>
					</li>
					<li v-if="page_list.length > 0 && page_list[0] > 1">
						<span>...</span>
					</li>
					<li v-bind:class="{ 'active': page == p }" v-for="p in page_list" :key="p">
						<a href="#" @click.prevent="choose_page(p)">{{ p }}</a>
					</li>
					<li v-if="page_list.length > 0 && page_list[page_list.length - 1] < page_count">
						<span>...</span>
					</li>
					<li>
						<a v-if="page_count > page" href="#" @click.prevent="choose_page(page + 1)">▶</a>
						<span v-else>▶</span>
					</li>
				</ul>	
			</div>
		</article>
	</main>
	<footer>
		<div id="footer_copy_w">
			<a href="https://www.osaka-u.ac.jp/ja" target="_blank"><img src="image/logo_ou.svg" align="left" alt="大阪大学"></a>
			(C) The University of Osaka.
		</div>
	</footer>
  </div>
  </body>
</template>

<script>
import config from '../config'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import HowToUse from "./HowToUse.vue";
import HowToUseHeader from "./HowToUseHeader.vue";
import HowToUseMobile from "./HowToUseMobile.vue";

export default {
  name: 'list',
  components: {
	  Loading,
	  HowToUse,
	  HowToUseHeader,
	  HowToUseMobile
  },
  data() {
	  return {
//		host: 'http://sra-tohoku-v2-public.s3-website-ap-northeast-1.amazonaws.com',
//		host: 'http://osaka-u.rd.public.s3-website-ap-northeast-1.amazonaws.com',
		host: config.WEB_HOST,
//		lang: 'ja',
		keyword_top: '',
		keyword: '',
		name_top: '',
		name: '',
        operator: '',
		page: 1,
		size: 50,
		sort: '',
		org_lv1: '',
		org_lv2: '',
		area_lv1: '',
		area_lv2: '',
		job: '',
		researchers: [],
		organizations: [],
		research_areas: [],
		jobs: [],
		visiting: [],
		visiting_name: ['招へい教員',
						'招へい教員Ｒ',
						'招へい研究員',
						'招へい研究員Ｒ'],
		response_organizations_lv1: [],
		response_organizations_lv2: [],
		response_disciplines: [],
		response_research_fields: [],
		response_jobs: [],
		total: 0,
		start: 0,
		end: 0,
		isLoading: false
	  }
  },
  created() {

	/*
	const lang = this.$route.query.lang == 'en' ? 'en': 'ja';
	this.$i18n.locale = lang;
	*/

	/*
	this.keyword = this.$route.query.k || '';
	this.org_lv1 = this.$route.query.o1 || '';
	this.org_lv2 = this.$route.query.o2 || '';
	this.area_lv1 = this.$route.query.a1 || '';
	this.area_lv2 = this.$route.query.a2 || '';
	this.job = this.$route.query.j || '';

	this.page = this.$route.query.page || 1;
	this.size = this.$route.query.size || 50;
	*/

	this.$i18n.locale = this.$store.state.lang;
	
	const params = this.$store.state.query;
	this.keyword = params.keyword;
	this.name = params.name;
	this.operator = params.operator;
	this.job = params.job;
	this.org_lv1 = params.org_lv1;
	this.org_lv2 = params.org_lv2;
	this.area_lv1 = params.area_lv1;
	this.area_lv2 = params.area_lv2;
	this.page = params.page;
	this.sort = params.sort;
	this.size = params.size;

	if (this.$route.query.k ||  
		this.$route.query.j ||  
		this.$route.query.o1 || this.$route.query.o2 || 
		this.$route.query.a1 || this.$route.query.a2)  {

		this.reset_query();

		this.keyword = this.$route.query.k || '';
		this.job = this.$route.query.j || '';
		this.org_lv1 = this.$route.query.o1 || '';
		this.org_lv2 = this.$route.query.o2 || '';
		this.area_lv1 = this.$route.query.a1 || '';
		this.area_lv2 = this.$route.query.a2 || '';
		this.page = this.$route.query.page || 1;
		this.size = this.$route.query.size || 50;
		this.sort = '';

		const requested_lang = this.$route.query.lang || 'ja';

		// クエリパラメータで指定された言語が現在の設定言語と違う場合は設定して画面をリロードする
		switch (requested_lang) {
			case 'ja':
			case 'en':
				if (requested_lang != this.lang) {
					this.$store.commit('save_lang', requested_lang);
					this.$router.go({path: this.$router.currentRoute.path, force: true});
					return;
				}
		}
	}

	axios.get(config.WEB_HOST + '/master/research_areas.json')
		.then((response) => {
			this.research_areas = response.data;
		});

	axios.get(config.WEB_HOST + '/master/organizations.json')
		.then((response) => {
			this.organizations = response.data;
		});

	axios.get(config.WEB_HOST + '/master/jobs.json')
		.then((response) => {
			this.jobs = response.data;
		});

	axios.get(config.WEB_HOST + '/master/visiting.json')
		.then((response) => {
			this.visiting = response.data;
		});

	this.search();
  },
  mounted() {
    $(function() {
		$(".accordion .nest").hide();
		$(".accordion .button").on("click", function() {
			$(this).next().slideToggle();
			$(this).toggleClass("active");
		});

		$(".accordion_big .nest_big").hide();
		$(".accordion_big .button_big").on("click", function() {
			$(this).next().slideToggle();
			$(this).toggleClass("active");
		});
	});
  },
  methods: {
		change_locale() {
			this.$emit('change-locale')
		},
		search_and_go_to_top: function() {
			this.page = 1;
			this.search();
		},
		search: function() {

			this.$store.commit('save_query', {
				keyword: this.keyword,
				name: this.name,
				operator: this.operator,
				area_lv1: this.area_lv1,
				area_lv2: this.area_lv2,
				org_lv1: this.org_lv1,
				org_lv2: this.org_lv2,
				job: this.job,
				page: this.page,
				size: this.size,
				sort: this.sort
			});

			const params = {
				'k': this.keyword,
				'n': this.name,
				'ope': this.operator,
				'a1': this.area_lv1,
				'a2': this.area_lv2,
				'o1': this.org_lv1,
				'o2': this.org_lv2,
				'j': this.job,
				'page': this.page,
				'size': this.size,
				'lang': this.lang,
				'sort': this.sort
			}

//			const url = 'https://6ssx2npeg6.execute-api.ap-northeast-1.amazonaws.com/default/query_for_es'
//			const url = 'https://he87qhem95.execute-api.ap-northeast-1.amazonaws.com/default/rmap-v2-query-for-es'

			this.isLoading = true;

			axios.get(config.QUERY_ENDPOINT, {'params': params})
				.then((response) => {
					this.researchers = response.data.hits;

					const hits = response.data?.hits || [];
					const visitingNames = ['招へい教員', '招へい教員Ｒ', '招へい研究員', '招へい研究員Ｒ'];

					// ■ this.visiting (S3の visiting.json) を urn(id) -> 配列 に索引化
					const visitingById = {};
					(this.visiting || []).forEach(v => {
					const key = String((v && v.id) || '');
					if (!key) return;
					if (!visitingById[key]) visitingById[key] = [];
					visitingById[key].push(v);
					});

					// ■ 研究者ごとに isVisiting / visiting を付与
					this.researchers = hits.map(r => {
						const visitList = Array.isArray(r?.visit) ? r.visit : [];

						let fromVisit = visitList
								.filter(v => visitingNames.includes(v?.job_name_ja))
								.map(v => {
								const lv1Code = v?.org_code_lv1 || '';
								const lv2Code = v?.org_code_lv2 || '';
								const orgJaLv1 = v?.org_name_lv1_ja;
								const orgEnLv1 = v?.org_name_lv1_en; 
								const orgJaLv2 = v?.org_name_lv2_ja != undefined ? v?.org_name_lv2_ja : '';
								const orgEnLv2 = v?.org_name_lv2_en != undefined ? v?.org_name_lv2_en : '';
								const orgJa = orgJaLv1 + " " + orgJaLv2;
								const orgEn = orgEnLv1 + " " + orgEnLv2;
								const jobJa = v?.job_name_ja == "招へい教員" || v?.job_name_ja == "招へい教員Ｒ" ? "招へい教員" : '招へい研究員';
								const jobEn = v?.job_name_ja == "招へい教員" || v?.job_name_ja == "招へい教員Ｒ" ? "Visiting Academic Staff" : 'Visiting Academic Staff';                   // 英名が無ければ和名フォールバック
								return { orgJa, orgEn, jobJa, jobEn, lv1Code, lv2Code };
							});
						let visitingStrings = fromVisit;

						return {
							...r,
							isVisiting: visitingStrings.length > 0,
							visiting: visitingStrings 
						};
					});					

					this.response_organizations_lv1 = response.data.organizations_lv1;
					this.response_organizations_lv2 = response.data.organizations_lv2;
					this.response_disciplines = response.data.disciplines;
					this.response_research_fields = response.data.research_fields;
					this.response_jobs = response.data.jobs;

					this.total = response.data.total;
					this.start = response.data.start;
					this.end = response.data.end;

					this.isLoading = false;
				});
		},
		choose_organization: function(code, event) {
			const active = $(event.target).parent().hasClass('active');
			this.org_lv1 = active ? '' : code;
			this.org_lv2 = '';
		},
		choose_research_area: function(code, event) {
			const active = $(event.target).parent().hasClass('active');
			this.area_lv1 = active ? '' : code;
			this.area_lv2 = '';
		},
		choose_job: function(code, event) {
			const disabled = $(event.target).parent().hasClass('disabled');
			const active = $(event.target).parent().hasClass('active');
			this.job = active ? '' : code;
		},
		choose_sort: function(sort, event) {
			const active = $(event.target).parent().hasClass('active');
			this.sort = active ? '' : sort;
		},
		choose_size: function(size, event) {
			const active = $(event.target).parent().hasClass('active');
			this.size = active ? 50 : size;
		},
		choose_page: function(position) {
			this.page = position;
			this.search();
		},
		search_by_keyword() {
			/*
			const params = {}
			params['k'] = this.keyword;
			params['lang'] = this.lang;
			this.$router.push({name: 'list', query: params})
			*/

			this.reset_query();
			this.keyword = this.keyword_top;
			this.keyword_top = '';

			this.search_and_go_to_top();

			const obj = document.getElementById('head_search_icon');
			toggle_item('head_search', '', obj);
		},
		search_by_name() {
			/*
			const params = {}
			params['k'] = this.keyword;
			params['lang'] = this.lang;
			this.$router.push({name: 'list', query: params})
			*/

			this.reset_query();
			this.name = this.name_top;
			this.name_top = '';

			this.search_and_go_to_top();

			const obj = document.getElementById('head_search_icon');
			toggle_item('head_search', '', obj);
		},
		/*
		search_by(name, value) {
			const params = {}
			params[name] = value;
			params['lang'] = this.lang;
			this.$router.push({name: 'list', query: params})
		},
		*/
		search_by_area_lv1(value) {
			this.reset_query();
			this.area_lv1 = value;
			this.search_and_go_to_top();

			const obj = document.getElementById('head_search_icon');
			toggle_item('head_search', '', obj);
		},
		search_by_area_lv2(value) {
			this.reset_query();
			this.area_lv2 = value;
			this.search_and_go_to_top();

			const obj = document.getElementById('head_search_icon');
			toggle_item('head_search', '', obj);
		},
		search_by_org_lv1(value) {
			this.reset_query();
			this.org_lv1 = value;
			this.search_and_go_to_top();

			const obj = document.getElementById('head_search_icon');
			toggle_item('head_search', '', obj);
		},
		search_by_org_lv2(value) {
			this.reset_query();
			this.org_lv2 = value;
			this.search_and_go_to_top();

			const obj = document.getElementById('head_search_icon');
			toggle_item('head_search', '', obj);
		},
		reset_query() {
			this.keyword = '';
			this.job = '';
			this.org_lv1 = '';
			this.org_lv2 = '';
			this.area_lv1 = '';
			this.area_lv2 = '';
		},
		
  },
  computed: {
	  lang: function() {
		return this.$i18n.locale;
	  },
	  imgClass() {
      return `img_${this.lang}`;
    },
	  filtered_organizations: function() {
		  const codes = this.response_organizations_lv1;
		  console.log(codes);
		  return this.organizations.filter(function(e, i) {
			  return codes.find(o => e.code == o);
		  });
	  },
	  filtered_research_areas: function() {
		  const codes = this.response_disciplines;
		  return this.research_areas.filter(function(e, i) {
			  return codes.find(o => e.code == o);
		  });
	  },
	  filtered_jobs: function() {
		  const codes = this.response_jobs;
		  return this.jobs.filter(function(e, i) {
			  return codes.find(o => e.code == o);
		  });
	  },
	  page_list: function() {
		  const links = [];
		  const count = this.page_count;
		  const range = 4;
		  for (var i = 1; i <= count; i++) {
			  if (i >= this.page - range && i <= this.page + range) {
				  links.push(i);
			  }
		  }
		  return links;
	  },
	  page_count: function() {
		  return Math.ceil(this.total / this.size);
	  }
  }
}
</script>

<style scoped>
/* list.css */

@charset "utf-8";
/* CSS Document */


/* main
======================================== */

h2{
	font-size:1.2rem;
	font-weight:600;
	color:#2d287f;
}
h3{
	font-size:0.8rem;
	font-weight:400;
	padding: 0 0 20px;
}
h4{
	font-size:1.2rem;
	font-weight:500;
	padding: 20px 0 7px 10px;
}
h5{
	font-size:0.8rem;
	font-weight:300;
	padding: 0 0 0 10px;
}
h6{
	font-size:0.9rem;
	font-weight:400;
	color:#2d287f;
	padding: 7px 0 0 10px;
	line-height:1.2;
}
h4 a{
/*	color:#2d287f;
*/	text-decoration:none;
	color:#333;
}
h5 a{
/*	color:#2d287f;
*/	text-decoration:none;
	color:#333;
}
h6 a{
/*	color:#2d287f;
*/	text-decoration:none;
	color:#333;
}

@media screen and (max-width: 480px) {
	h4{
		font-size:1.2rem;
		font-weight:500;
		color:#2d287f;
		padding: 10px 0 5px 0px;
	}
	h5{
		padding: 0px;
	}
	h6{
		padding: 5px 0 0 0px;
	}
}

main{
	display:-webkit-box;
  	display:-ms-flexbox;
	display: flex;
	width: 100%;
/*	max-width: 1200px;*/
	margin: 0 auto;
}


/* search_more_r
======================================== */

.search_more_r_wrapper{
	border: #2d287f solid 2px;
	border-radius: 25px;
	margin: 0 0 50px;
	padding:0;
}

@media screen and (min-width: 960px) {
.search_more_r_wrapper{
		display: none;
	}
}

.search_more_r{
	border-radius: 25px;
	height: 50px;
	display:-webkit-box;
  	display:-ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	-webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
	align-items: center;
	padding: 0 10px 0;
	font-weight: 600;
	background-color:#fff;
	color:#2d287f;
	text-decoration:none;
}


#search_more{
	height:0;
	overflow-y:hidden;

}

.disp_u960{
margin: 0px 25px 0px;
	}


@media screen and (min-width: 960px) {
	.disp_u960{
		display: none;
	}
}
@media screen and (max-width: 960px) {
		.search_container_in{
		background-color: #fff;
		padding: 0 0 50px;
	}	
}




/* res_container
======================================== */

#res_container{
	padding: 50px 50px;
	width: 100%;
}

@media screen and (max-width: 480px) {
	#res_container{
		padding: 50px 10px;
	}
}



/* res_list
-------------------- */

*, *:before, *:after {
	box-sizing: border-box;
}

#res_list {
	width: 100%;
	display: flex;
	display: -ms-flexbox;
	flex-wrap: wrap;
	-ms-flex-wrap: wrap;
}

#res_list > dl{
	display: flex; 
	align-items: center; 
	border-bottom: 1px solid #e0e0e0;
	margin: 0  ;
	margin-bottom: 0 ;
	width: 100% !important;
	padding: 0 !important;
}

@media screen and (max-width: 1600px) {
	#res_list > dl{
		width: 33.33333%;
		padding: 0 5px 50px 5px;
	}
}
@media screen and (max-width: 720px) {
	#res_list > dl{
		width: 50%;
		padding: 0 5px 30px 5px;
	}

}


#res_list dl dt:hover img{
  opacity: 0.9;
  filter: alpha(opacity=80);
  -moz-opacity: 0.5;
  -webkit-transition: 0.2s ease-in-out;
  -moz-transition: 0.2s ease-in-out;
  -o-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}


@media screen and (max-width: 720px) {
	#res_list dl dt img{
		width: 100%;
		padding: 0 0px 0px 0px;
	}

}

#res_list a{
	text-decoration:none;
	-webkit-transition: 0.2s ease-in-out;
	-moz-transition: 0.2s ease-in-out;
	-o-transition: 0.2s ease-in-out;
	transition: 0.2s ease-in-out;
}

#res_list a:hover{
	color: #0f0f5b;
}

#res_list dl dt {
	position: relative;
	width: 1%;
	height:auto;
	padding: 50px;
	overflow: hidden;
	margin-right: 15px;
  }

#res_list dl dd {
	flex-grow: 1; 
	margin-bottom: 1.1rem !important
  }

#res_list dl dt img{
	width:100%;
    height:auto;
	position: absolute;
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	max-width: 100%;
	max-height: 100%;
	object-fit: contain;
	font-family: 'object-fit: contain;';

}


/* page_nav
-------------------- */

.page_nav{
	text-align: center;
}
.page_nav ul{
	display:-webkit-box;
  	display:-ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: center;
}
.page_nav ul li{
	list-style:none;
	padding: 0px 5px;
	font-size:0.9rem;
}
.page_nav ul li a,
.page_nav ul li span {
	text-decoration: none;
	color: #999999;
}

.page_nav ul li.active a{
	color: #2d287f;
}

.page_nav ul li a:hover{
	color: #2d287f;
}
</style>